import { SeoProvider } from './../../services/seo';
import { LangService } from '../../services/lang.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { UtilService } from '../../services/util.service';
import { RestService } from '../../services/rest.service';
import { FPObjectProperties } from '../../services/types-t';
import { IonContent, LoadingController, ModalController, NavController, Platform, PopoverController, ToastController } from '@ionic/angular';
import { AfterContentChecked, ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { SwiperComponent } from 'swiper/angular';
import { SwiperOptions } from 'swiper';
import { GoogleAuth } from "@codetrix-studio/capacitor-google-auth";
// import Swiper core and required modules
import SwiperCore, { Navigation, Pagination } from 'swiper';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MoreInfoComponent } from 'src/app/modal/more-info/more-info.component';
import { OptionBuyComponent } from 'src/app/popover/option-buy/option-buy.component';
import { OptionSubscribeComponent } from 'src/app/popover/option-subscribe/option-subscribe.component';
import { OptionBuyDataComponent } from 'src/app/popover/option-buy-data/option-buy-data.component';
import { Share } from '@capacitor/share';
// Pixel library importing
import { PixelService } from 'ngx-pixel';
import { ShareMenu } from "share-menu";
import { Device } from '@capacitor/device';
import { Capacitor } from '@capacitor/core';
import { OAuthProvider, signInWithPopup } from 'firebase/auth';
import { Auth, UserCredential } from '@angular/fire/auth';
import { TrackingProvider } from 'src/app/services/tracking';
import { AnalyticsType } from 'src/app/services/types-t';

// install Swiper modules
SwiperCore.use([Navigation, Pagination]);
@Component({
  selector: 'app-course-detail',
  templateUrl: './course-detail.page.html',
  styleUrls: ['./course-detail.page.scss'],
})
export class CourseDetailPage implements OnInit, AfterContentChecked {
  isMobile: boolean;
  @ViewChild('slidesCourse2') swiper: SwiperComponent;
  @ViewChild(IonContent) content: IonContent;
  @ViewChild('popoverShare') popoverShare;
  fpProperties: Partial<FPObjectProperties> = {
    content_category: 'course',
    content_type: 'product',
  };
  maxAlbum = 8;
  slidesCourse2: SwiperOptions = {
    initialSlide: 1,
    slidesPerView: 3.7,
    spaceBetween: 24,
    navigation: true,
    centeredSlides: true,
    centeredSlidesBounds: true,
    allowSlidePrev: true,
    allowSlideNext: true,
    slideToClickedSlide: true
  };
  slidesCourse2T: SwiperOptions = {
    initialSlide: 1,
    slidesPerView: 3.7,
    spaceBetween: 24,
    navigation: true,
    centeredSlides: true,
    centeredSlidesBounds: true,
    allowSlidePrev: true,
    allowSlideNext: true,
    slideToClickedSlide: true
  };

  slidesCourse5M: SwiperOptions = {
    initialSlide: 1,
    slidesPerView: 1,
    spaceBetween: 16,
    navigation: true,
    centeredSlides: true,
    centeredSlidesBounds: true,
    allowSlidePrev: true,
    allowSlideNext: true,
    slideToClickedSlide: true
  };

  slidesCourse2TM: SwiperOptions = {
    initialSlide: 1,
    slidesPerView: 1.2,
    spaceBetween: 12,
    navigation: true,
    centeredSlides: true,
    centeredSlidesBounds: true,
    slideToClickedSlide: true
  };

  slidesCourse5: SwiperOptions = {
    initialSlide: 1,
    slidesPerView: 3.2,
    spaceBetween: 32,
    navigation: true,
    centeredSlides: true,
    centeredSlidesBounds: true,
    allowSlidePrev: true,
    allowSlideNext: true,
    slideToClickedSlide: true
  };

  banners: any[] = [];
  user: any;
  videosCourse: any[] = [];
  videosCourseHelp: any[] = [];
  helpLoop2: boolean;
  helpLoop: boolean;
  canalesData: any[] = [];
  courses: any[] = [];
  allCourses: any[];
  loadMostWanted: boolean;
  helpFocus: boolean;
  showOverSearch: boolean;
  searchTop: string;
  auxLoading: any;
  coursesWatch: any[] = [];
  loadAll: boolean;
  filterType: any = 3;
  id: string;
  course: any;
  widthList: number;
  firstLoad: boolean;
  bandImg: boolean;
  showButton: boolean;
  secDetail: any[];
  seeAllAlbumbs: boolean;
  futureEmail: any;
  coupon: any;
  refCode: string;
  lastVideoTarget: any;
  currentVideoIndex: number = 0;
  currentSectionIndex: number = 0;
  private nextFirstSection: boolean;
  modalSuscription: boolean;
  isMacOS: boolean;
  isOpenPopover: boolean;
  modeIosPrice: boolean = false;
  infoPlatform: any;
  promotion: any;
  promotion_course: any;
  showModalLogin: boolean = false;
  selectedTranslation: any;

  constructor(
    public rest: RestService,
    public navCtrl: NavController,
    public loadingCtrl: LoadingController,
    public util: UtilService,
    public platform: Platform,
    private cdRef: ChangeDetectorRef,
    public domSanitizer: DomSanitizer,
    private translate: TranslateService,
    private route: ActivatedRoute,
    public langService: LangService,
    public seoService: SeoProvider,
    public modalCtrl: ModalController,
    public popoverCtrl: PopoverController,
    public toastCtrl: ToastController,
    private pixel: PixelService,
    private saveRouter: Router,
    private auth: Auth,
    private trackingProvider: TrackingProvider
  ) {

    Device.getInfo().then(info => {
      this.infoPlatform = info.operatingSystem;
      //console.log('infoPlatform', this.infoPlatform);
      if (this.platform.is('android') || this.platform.is('ios')) {
        this.isMobile = true;
        if (this.platform.is('ios') && this.infoPlatform === 'ios') {
          if (this.platform.is('mobileweb')) {
            this.modeIosPrice = false;
          } else {
            this.modeIosPrice = true;
          }
        }
      }
    });
    this.rest.getStorage('user').then((val) => {
      this.user = val;
      console.log('From Course Detail. User:', val);
    })
    this.langService.getLanguajeStorage().then((val => {
      if (val) {

        console.log('>>>XXX1-home', val);
        this.reloadTrans(val);
      } else {
        console.log('>>>XXX3');
        this.reloadTrans('es');
      }
    })).catch((err) => {
      console.log('>>>XXX5');
      this.reloadTrans('es');
    });
    this.isMacOS = (navigator.userAgent.indexOf('Macintosh') > 0 && navigator.userAgent.indexOf('Safari') > 0 && navigator.userAgent.indexOf('Chrome') <= 0) ? true : false;
  }

  private reloadTrans(lang) {
    this.translate.use(lang);
    this.langService.setTranslateLanguage(lang);
  }

  ngAfterContentChecked() {
    if (this.swiper) {
      this.swiper.updateSwiper({})
    }

    this.cdRef.detectChanges();
  }

  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id');
    this.id = this.id.split('-')[0];
    //console.log('id', this.id);
    this.loadClassById();
    const that = this;
    window.addEventListener('message', function (data) {
      //console.log('Received data');
      that.receiveMessage(data);
    }, false);
  }

  ionViewDidEnter() {
    this.promotion = localStorage.getItem("promotion");
    this.promotion_course = localStorage.getItem("promotion_course");

    this.rest.getStorage('user').then((val) => {
      this.user = val;
      console.log('From Course Detail. User:', val);
    })

    setTimeout(() => {
      console.log('ionViewDidEnter', this.user, this.promotion, this.promotion_course);

      if (this.user && this.promotion && this.promotion_course) {
        this.handlePromotionRequest();
      }
    }, 1000);
  }


  receiveMessage(event) {
    if (!this.course || !this.course.sections) { return; }

    let auxItem = this.course.cover_videos ? this.course.cover_videos[0] : null;
    let help = false
    for (const ita of this.course.sections) {
      for (const iterator of ita.listVideos) {
        //console.log(iterator)
        if (help) {
          iterator.url = iterator.url + '?autoplay=1'
          // this.lastVideoTarget = document.getElementById('video_' + iterator.id);
          this.seeVideoSec(null, iterator, true)
          help = false
        }
        if (auxItem && iterator.id == auxItem.id) {
          iterator.finished = true;
          help = true
        }
      }
    }
  }

  async loadClassById(flag?) {
    //console.log('loadClassById');
    const auxLoading = await this.loadingCtrl.create({
    });
    await auxLoading.present();
    let apiHelp = '';
    if (this.user != null) {
      apiHelp = 'courses/';
    } else {
      apiHelp = 'courses/guest/';
    }
    this.rest._get(apiHelp + this.id, 'get').subscribe(response => {
      /*f (flag && !res.data.course.purchased) {
        return;
      }*/
      const res: any = response.body;
      this.course = res.data.course;

      setTimeout(() => {
        this.loadAll = true;
      }, 1000);
      let newLang = this.langService.getTranslateLanguage();
     
      const browserLanguage = newLang ?? navigator.language;

      if (this.course?.translations && this.course.translations.length > 0) {
        this.selectedTranslation = this.course.translations.find(
          (translation: any) =>  translation.language.substring(0, 2) === browserLanguage.substring(0, 2)
        );
      }
      console.log('acaaaaaaaaaaaaaaa',this.selectedTranslation)
      if (this.course?.videos && this.course.videos.length > 0) {
        this.course.videos.forEach((video: any) => {
          const videoTranslation = video.translations?.find(
            (translation: any) =>  translation.language.substring(0, 2) === browserLanguage.substring(0, 2)
          );
      
          if (videoTranslation) {
            video.description = videoTranslation.description;
          }
        });
      }
      this.course.html_description = this.domSanitizer.bypassSecurityTrustHtml(this.course.html_description);
      this.rest._get('discs/user/' + this.course.owner.id, 'get').subscribe(response2 => {
        const res2: any = response2.body;

        setTimeout(() => {
          auxLoading.dismiss();
          if (document.getElementById('listClassVideoDetail')) {
            //console.log(document.getElementById('listClassVideoDetail').offsetWidth);
            this.widthList = document.getElementById('listClassVideoDetail').offsetWidth;
            if (this.platform.is('android') || this.platform.is('ios')) {
              this.widthList = this.widthList / 3;
            } else {
              this.widthList = 500 / 3;
            }

          }
        }, 1000);
        let auxRes: any = res2;
        auxRes = auxRes.data.discs;
        auxRes = auxRes.sort((a, b) => new Date(b.release_date).getTime() - new Date(a.release_date).getTime());
        this.course.albums = auxRes;
      }, (resr) => {

        //this.loading.dismiss();
        console.log(resr);
      });
      for (const ita of this.course.colaborators) {
        //console.log(ita);
        this.rest._get('discs/user/' + ita.participant.id, 'get').subscribe(responseX2 => {
          const res2x: any = responseX2.body;
          //console.log(res2x);
          let auxRes: any = res2x;
          auxRes = auxRes.data.discs;
          auxRes = auxRes.sort((a, b) => new Date(b.release_date).getTime() - new Date(a.release_date).getTime());
          ita.participant.albums = auxRes;
        }, (err) => {
          console.log(err);
        });
      }
      for (const iterator of this.course.cover_videos) {
        if (iterator.url) {
          iterator.safeUrl = this.getSafeUrlYoutube(iterator.url, iterator.autoplay, true);
        }
      }
      if (this.user != null && (this.user.premium === 'S' || 'N')) {
        //console.log(this.user.user_id);
        if (this.user.user_id == this.course.owner.id) {
          this.user.purchased = true;
          this.user.free = true;
        }
      }

      this.bandImg = true;
      this.showButton = this.getValid();
      for (const itax of this.course.sections) {
        this.getVideosSection(itax, this.course.sections.length);
      }
      this.putLastVideo();

      if (!this.course) {
        if (auxLoading) {
          auxLoading.dismiss();
        }
        this.navCtrl.back();
      }
      // Updates SEO meta tags
      this.seoService.customizeMetaPageInfo({
        title: `Louderband | ${this.course.title}`,
        description: this.course.description,
        url: `https://www.louderband.com/courses/${this.course.id}`,
        image: this.course.cover,
        slug: this.course.slug,
      });
      if (!this.firstLoad) {
        // Notifies Facebook Pixel the course was checked
        delete this.fpProperties.contents;
        this.fpProperties = {
          ...this.fpProperties,
          content_ids: [this.course.id],
          content_name: this.course.title,
          currency: this.course.currency,
          value: this.getPrice(this.course),
        };
        // this.trackingProvider.fbqWrapper('ViewContent', this.fpProperties as FPObjectProperties);
      }
      this.firstLoad = true;
    }, (err) => {
      if (this.auxLoading) {
        this.auxLoading.dismiss();
      }
      console.error('There was an error loading this data', err);
    });
  }

  putLastVideo() {
    setTimeout(() => {
      let id = '';
      for (const itax of this.course.videos) {
        if (itax.finished) {
          id = itax.id
        }
      }
      for (const itax of this.course.videos) {
        if (itax.inprogress) {
          id = itax.id
        }
      }
      for (const iterator of this.course.sections) {
        for (const ita of iterator.listVideos) {
          if (id == ita.id) {
            this.lastVideoTarget = document.getElementById('video_' + ita.id);
            //console.log('last_video', this.lastVideoTarget, ita.id);
            this.seeVideoSec(null, ita, true);
          }
        }
      }
      console.log(id);
    }, 3000);
  }

  async seeNextVideoSec() {
    if (!this.course?.purchased) {
      //console.log('showModalSuscription');
      this.showModalSuscription();
    } else {
      const loadtest = await this.loadingCtrl.create({ duration: 2000 });
      if (this.course?.sections?.length > 0 && this.currentSectionIndex < this.course?.sections?.length) {
        const currentSection = this.course.sections[this.currentSectionIndex];
        const videos = this.seeDetailSectionWeb(currentSection, this.course.videos);
        loadtest.present();

        if (this.nextFirstSection === true) {
          if (this.currentVideoIndex < videos.length - 1) {
            this.currentVideoIndex++;
          } else if (this.currentSectionIndex < this.course?.sections?.length - 1) {
            this.currentSectionIndex++;
            this.currentVideoIndex = 0;
          }

          if (this.lastVideoTarget) {
            this.lastVideoTarget.style.color = '#a5a1aa';
            this.lastVideoTarget.style.weight = 'normal';
          }
        }
        this.lastVideoTarget = document.getElementById('video_' + videos[this.currentVideoIndex].id);
        this.seeVideoSec(null, videos[this.currentVideoIndex], true, this.currentSectionIndex, this.currentVideoIndex);
      }
    }
  }

  seePrevVideoSec() {
    if (this.course?.sections?.length > 0 && this.currentSectionIndex >= 0) {
      const currentSection = this.course.sections[this.currentSectionIndex];
      const videos = this.seeDetailSectionWeb(currentSection, this.course.videos);

      if (this.currentVideoIndex > 0) {
        this.currentVideoIndex--;
      } else if (this.currentSectionIndex > 0) {
        this.currentSectionIndex--;
        this.currentVideoIndex = 0;
      }

      if (this.lastVideoTarget) {
        this.lastVideoTarget.style.color = '#a5a1aa';
        this.lastVideoTarget.style.weight = 'normal';
      }
      this.lastVideoTarget = document.getElementById('video_' + videos[this.currentVideoIndex].id);
      this.seeVideoSec(null, videos[this.currentVideoIndex], true, this.currentSectionIndex, this.currentVideoIndex);
    }
  }

  seeVideoSec(event, item, flag?, sectionIndex?, videoIndex?) {
    if (!this.course?.purchased) {
      //console.log('showModalSuscription');
      this.showModalSuscription();
    } else {
      this.nextFirstSection = true;
      //console.log('eveeeent', (event && event.target) ? event.target : '');
      this.currentVideoIndex = videoIndex;
      this.currentSectionIndex = sectionIndex;

      if ((event && event.target)) {
        if (this.lastVideoTarget) {
          this.lastVideoTarget.style.color = '#a5a1aa';
          this.lastVideoTarget.style.weight = 'normal';
        }

        this.lastVideoTarget = event.target;
        event.target.style.color = 'white';
        event.target.style.weight = 'bold';
      } else {
        this.lastVideoTarget.style.color = 'white';
        this.lastVideoTarget.style.weight = 'bold';
      }

      if (this.course.purchased || this.course.free || item.is_preview) {
        this.reloadVideo(item, flag);
      }
    }
    // this.testSaveVideo('https://drive.google.com/uc?id=0B2j2vM_eiSrodGVqa3kxblpDaTlGMjNsc01McU9jX3c1R0pr&export=download');
  }

  async reloadVideo(item, flag?) {
    //console.log(item);
    const loadtest = await this.loadingCtrl.create({ duration: 2000 });
    if (!flag) {
      await loadtest.present();
    }
    this.course.cover_videos = [];
    this.course.cover_videos.push(item);
    for (const iterator of this.course.cover_videos) {
      if (iterator.url) {
        iterator.safeUrl = this.getSafeUrlYoutube(iterator.url, iterator.autoplay);
      }
    }
    //console.log(this.course);
    this.content.scrollToTop(300);
  }


  getVideosSection(item, qty) {
    // item.see = !item.see;
    this.secDetail = [];
    for (const iterator of this.course.videos) {
      if (iterator.section_id == item.id) {
        this.secDetail.push({
          id: iterator.id,
          finished: iterator.finished,
          is_preview: iterator.is_preview,
          cover: iterator.cover,
          time_duration: iterator.time_duration,
          video_provider_id: iterator.video_provider_id,
          title: iterator.title,
          description: iterator.description,
          url: iterator.url
        });
      }
    }
    if (this.secDetail.length == 1) {
      item.see = true;
    }
    if (qty == 1) {
      item.see = true;
      item.only = true;
    }
    item.listVideos = this.secDetail;
  }

  getValid() {
    if (this.course) {
      if (this.course.free) {
        return false;
      } else {
        if (this.course.purchased) {
          return false;
        } else {
          return true;
        }
      }
    } else {
      return false;
    }
  }

  getSafeUrlYoutube(a: any, autoplay, first?) {
    let aux = a.split('&');
    a = aux[0];
    let rare = a.search("https://youtu.be/");
    let video: any;
    //console.log(rare);
    if (rare >= 0) {
      let videoSafe: SafeResourceUrl = a.replace("https://youtu.be/", "https://youtube.com/embed/");
      video = videoSafe;
      //console.log('video ' + video);
      if (autoplay) {
        video = video + '?autoplay=1';
        if (first) {
          video = video + '&mute=1';
        }
      } else {
        if (first) {
          video = video + '?mute=1';
        }
      }
      video = this.domSanitizer.bypassSecurityTrustResourceUrl(video);
      //console.log('video ' + video);
    } else {
      let videoSafe: SafeResourceUrl = a.replace("watch?v=", "embed/");
      video = videoSafe;
      let x = video.search("//m.");
      if (x > 0) {
        video = video.replace("//m.", "//");
      }
      //console.log('video ' + video);
      if (autoplay) {
        video = video + '?autoplay=1'
        if (first) {
          video = video + '&mute=1';
        }
      } else {
        if (first) {
          video = video + '?mute=1';
        }
      }
      video = this.domSanitizer.bypassSecurityTrustResourceUrl(video);
    }
    return video;
  }

  outData2(ev) {
    //console.log(ev);
    if (ev.banners) {
      this.banners = ev.banners
    }
  }

  gotoOldApp(view?) {
    //console.log(view);

    if (view) {
      this.navCtrl.navigateForward(view);
    } else {
      window.open('https://louderband.com/', '_self');
    }
  }

  outData(ev) {
    if (ev && ev.editProfile) {
      this.navCtrl.navigateForward('mi-perfil');
    }
    //console.log(ev);
    if (ev && ev.focus) {
      this.showOverSearch = true;
      if (ev.search === '') {
        this.searchTop = '';
      }
      setTimeout(() => {
        this.helpFocus = true;
      }, 1800);
    }

    if (ev && ev.login) {
      // this.openLogin();
      this.navCtrl.navigateRoot('/login')
    }

    if (ev && ev.home) {
      // this.openLogin();
      this.navCtrl.navigateRoot('/home')
    }
    if (ev && ev.referred) {
      let url = '/referred';
      this.navCtrl.navigateRoot(url);
    }

    if (ev && ev.old) {
      // this.navCtrl.navigateRoot('/registro')
      this.gotoOldApp(ev.view);
    }




    if (ev && ev.search) {
      //console.log(ev.search);
      this.searchTop = ev.search;

    }

    if (ev && typeof ev.isMobile === 'boolean') {
      // console.log(ev);
      this.isMobile = ev.isMobile;
    }

  }

  getCurrency(item: any) {
    if (item.has_subscription && item.has_subscription.length) {
      return item.has_subscription[0].price ? item.has_subscription[0].price.currency : item.has_subscription[1].price.currency;
    }
    return item.currency;
  }

  getPrice(item: any) {

    // if (this.platform.is('ios')) {
    //   if (item.ios_offer_price) {
    //     return item.ios_offer_price;
    //   } else if (item.offer_price) {
    //     return item.offer_price;
    //   }
    // }

    // if (this.platform.is('android')) {
    //   if (item.android_offer_price) {
    //     return item.android_offer_price;
    //   } else if (item.offer_price) {
    //     return item.offer_price;
    //   }
    // }

    if (item.has_subscription && item.has_subscription.length && !this.modeIosPrice) {
      return item.has_subscription[0].price ? item.has_subscription[0].price.offer_price : item.has_subscription[1].price.offer_price;
    }
    if (item.has_subscription && item.has_subscription.length && this.modeIosPrice) {
      return item.has_subscription[0].price ? item.has_subscription[0].price.ios_price : item.has_subscription[1].price.ios_price;
    }

    if (item.offer_price) {
      return item.offer_price;
    } else {
      return item.price;
    }

  }

  getPriceOld(item) {

    // if (this.platform.is('ios') && item.ios_offer_price) {
    //   if (item.ios_price) {
    //     return item.ios_price;
    //   } else if (item.price) {
    //     return item.price;
    //   }
    // }

    // if (this.platform.is('android') && item.ios_offer_price) {
    //   if (item.android_price) {
    //     return item.android_price;
    //   } else if (item.price) {
    //     return item.price;
    //   }
    // }

    if (item.price && item.offer_price) {
      return this.util.getFixed(item.price, this.course.currency);
    }

  }

  getW(list) {
    const aux = [];
    for (const iterator of list) {
      if (iterator.see) {
        aux.push(iterator)
      }
    }
    return aux.length * 73;
  }

  handleIFrameLoadEvent() {
    //console.log('handleIFrameLoadEvent')
    if (this.loadAll) {
      // this.loading.dismiss();
      // this.loadAll = false;
    }
  }


  getFile(val) {
    if (!this.course.purchased) {
      return;
    }
    //console.log(val);
    window.open(val.url, '_blank');
    // this.rest._getLocal(val.url).subscribe((data) => {
    //   if (data) {
    //     console.log(data);
    //     const aux: any = data;
    //     console.log(aux);
    //     window.open(aux.url, '_blank');
    //   }
    // }, error => {
    //   console.log(error);
    // });

  }

  goToDisc(val, owner) {

  }


  goCourses() {
    this.navCtrl.navigateBack('cursos');
  }

  seeDetailSectionWeb(item, videos: any[]): any[] {
    if (videos && videos.length > 0) {
      return videos.filter(video => video.section_id === item.id);
    }

    return [];
  }

  seeMaxAlbums() {
    this.maxAlbum = this.course.albums.length;
    this.seeAllAlbumbs = true;
  }

  getLast(listInner, k, sections, i) {
    if (sections.length - 1 == i && listInner.length - 1 == k) {
      return true;
    } else {
      return false;
    }
  }

  isUnlocked(course) {
    return this.course.purchased || this.course.free || course.is_preview;
  }

  async showInfo() {
    //console.log(this.course);
    // return;
    const modal = await this.modalCtrl.create({
      component: MoreInfoComponent,
      componentProps: { course: this.course }
    });
    await modal.present();

    const { data } = await modal.onWillDismiss();
  }

  async giftCourseGuest(aux) {
    const loader = await this.loadingCtrl.create({});
    aux.force_web_price = 1;

    this.rest._post('courses/guest/gift/purchase', aux).subscribe(async res => {
      if (res) {
        loader.dismiss();
        const toast = await this.toastCtrl.create({
          message: 'Continua con el pago',
          duration: 3000,
          position: 'middle'
        });
        await toast.present();
        this.goToPaymentGateway(res.body, 'gift');
      }
    }, async (error) => {
      const toast = await this.toastCtrl.create({
        message: error.error.error,
        duration: 3000,
        position: 'middle'
      });
      await toast.present();
      loader.dismiss();
    });
  }

  async selectGift() {
    let auxBoolean = true;
    if (this.user != null) {
      auxBoolean = false;
    }
    const popover = await this.popoverCtrl.create({
      component: OptionBuyDataComponent,
      mode: 'ios',
      cssClass: 'pop-option-buy'
    });

    popover.present();
    const { data } = await popover.onDidDismiss();

    // console.log(data);
    if (data) {
      let aux: any = {
        course: this.course.id,
        from: data.data.name,
        to: data.data.email,
        url_coupon_code: this.refCode,
      };
      if (auxBoolean) {
        this.giftCourseGuest(aux);
      } else {
        this.giftCourse(aux);
      }
    }
  }

  async giftCourse(aux) {
    const loader = await this.loadingCtrl.create({});
    aux.force_web_price = 1;

    this.rest._post('courses/guest/gift/purchase', aux).subscribe(async res => {
      if (res) {
        loader.dismiss();
        const toast = await this.toastCtrl.create({
          message: 'Continua con el pago',
          duration: 2000,
          position: 'middle'
        });
        await toast.present();
        this.goToPaymentGateway(res.body, 'gift');
      }
    }, async (error) => {
      const toast = await this.toastCtrl.create({
        message: error.error.error,
        duration: 2000,
        position: 'middle'
      });
      await toast.present();
      loader.dismiss();
    });
  }

  goToPaymentGateway(res, type: 'buy' | 'gift') {
    let valsend = res.paymentUrl;
    // console.log('open ' + valsend);
    delete this.fpProperties.content_ids;
    // this.trackingProvider.fbqWrapper('AddToCart', {
    //   ...this.fpProperties,
    //   contents: [{ id: this.lesson.id, quantity: 1, type }],
    // } as FPObjectProperties);
    window.open(encodeURI(valsend), '_self');
  }

  buyNormal(loader, aux) {
    aux.force_web_price = 1;

    this.rest._post('courses/purchase', aux).subscribe(async res => {
      if (res) {
        loader.dismiss();
        const toast = await this.toastCtrl.create({
          message: 'Continua con el pago',
          duration: 2000,
          position: 'middle'
        });
        await toast.present();
        this.goToPaymentGateway(res.body, 'buy');
      }
    }, async (error) => {
      const toast = await this.toastCtrl.create({
        message: error.error.error,
        duration: 2000,
        position: 'middle'
      });
      await toast.present();
      loader.dismiss();
    });
  }

  buySubscriptionNormal(loader, aux) {
    aux.force_web_price = 1;

    this.rest._post('subscription/purchase', aux).subscribe(async res => {
      if (res) {
        loader.dismiss();
        const toast = await this.toastCtrl.create({
          message: 'Continua con el pago',
          duration: 2000,
          position: 'middle'
        });
        await toast.present();
        this.goToPaymentGateway(res.body, 'buy');
      }
    }, async (error) => {
      const toast = await this.toastCtrl.create({
        message: error.error.error,
        duration: 2000,
        position: 'middle'
      });
      await toast.present();
      loader.dismiss();
    });
  }

  buyWithOut(loader, aux) {
    aux.to = this.futureEmail;
    aux.force_web_price = 1;

    this.rest._post('courses/guest/purchase', aux).subscribe(async res => {
      if (res) {
        loader.dismiss();
        const toast = await this.toastCtrl.create({
          message: 'Continua con el pago',
          duration: 2000,
          position: 'middle'
        });
        await toast.present();
        this.goToPaymentGateway(res.body, 'buy');
      }
    }, async (error) => {
      const toast = await this.toastCtrl.create({
        message: error.error.error,
        duration: 2000,
        position: 'middle'
      });
      await toast.present();
      loader.dismiss();
    });
  }

  buySubscriptionWithOut(loader, aux) {
    aux.to = this.futureEmail;
    aux.force_web_price = 1;

    this.rest._post('subscription/guest/purchase', aux).subscribe(async res => {
      if (res) {
        loader.dismiss();
        const toast = await this.toastCtrl.create({
          message: 'Continua con el pago',
          duration: 2000,
          position: 'middle'
        });
        await toast.present();
        this.goToPaymentGateway(res.body, 'buy');
      }
    }, async (error) => {
      const toast = await this.toastCtrl.create({
        message: error.error.error,
        duration: 2000,
        position: 'middle'
      });
      await toast.present();
      loader.dismiss();
    });
  }

  async buy() {
    const loader = await this.loadingCtrl.create({});
    let aux: any = {
      course: this.course.id,
      force_web_price: 1,
      url_coupon_code: this.refCode,
    };
    if (this.coupon) {
      aux.coupon = this.coupon.coupon_id
    }
    if (this.user != null && (this.user.premium === 'S' || 'N')) {
      loader.present();
      this.buyNormal(loader, aux);
    } else {
      this.buyWithOut(loader, aux);
    }
  }

  async subscribe() {
    const loader = await this.loadingCtrl.create({});
    let aux: any = {
      subscription: this.course.has_subscription[0].id,
      force_web_price: 1,
      url_coupon_code: this.refCode,
      email: this.user?.email,
    };
    if (this.coupon) {
      aux.coupon = this.coupon.coupon_id
    }
    if (this.user != null && (this.user.premium === 'S' || 'N')) {
      loader.present();
      this.buySubscriptionNormal(loader, aux);
    } else {
      this.buySubscriptionWithOut(loader, aux);
    }
  }

  async optionBuy() {
    let auxBoolean = true;

    if (this.user != null) {
      auxBoolean = false;
    }

    const popover = await this.popoverCtrl.create({
      component: OptionBuyComponent,
      componentProps: { notAccount: auxBoolean, courseId: this.course.id },
      mode: 'ios',
      cssClass: 'pop-option-buy'
    });

    await popover.present();

    const { data } = await popover.onDidDismiss();

    // console.log(data);
    if (data) {
      if (data.coupon) {
        this.coupon = data.coupon;
      }
      if (auxBoolean && data.futureEmail) {
        this.futureEmail = data.futureEmail;
      }
      if (data.value == 'gift') {
        setTimeout(() => {
          this.selectGift();
        }, 2000);
      }
      if (data.value == 'buy') {
        this.buy();
      }
    };
  }

  async optionSubscribe() {
    let auxBoolean = true;

    if (this.user != null) {
      auxBoolean = false;
    }

    const popover = await this.popoverCtrl.create({
      component: OptionSubscribeComponent,
      componentProps: { notAccount: auxBoolean, subscriptionId: this.course.has_subscription[0].id },
      mode: 'ios',
      cssClass: 'pop-option-buy'
    });

    await popover.present();

    const { data } = await popover.onDidDismiss();

    // console.log(data);
    if (data) {
      if (data.coupon) {
        this.coupon = data.coupon;
      }
      if (auxBoolean && data.futureEmail) {
        this.futureEmail = data.futureEmail;
      }
      if (data.value == 'gift') {
        setTimeout(() => {
          this.selectGift();
        }, 2000);
      }
      if (data.value == 'buy') {
        this.subscribe();
      }
    };
  }

  gotoSuscription() {
    this.navCtrl.navigateForward('/suscripciones');
  }

  optionPromotion() {
    console.log(this.course);
    localStorage.setItem('promotion_course', this.course.id);
    this.promotion_course = this.course.id;

    if (!this.user) {
      this.showModalLogin = !this.showModalLogin;
    } else {
      this.handlePromotionRequest();
    }

    this.trackingProvider.trackPromotionCourseSelected(AnalyticsType.GOOGLE_ANALYTICS);
    this.trackingProvider.trackPromotionCourseSelected(AnalyticsType.FACEBOOK_PIXEL);
  }

  async shareCourse() {
    await Share.share({
      title: 'Visualiza este curso en Louderband',
      text: 'Disfruta de este curso en Louderband',
      url: 'https://louderband.com/courses/' + this.course.id + '-' + this.course.slug,
      dialogTitle: 'Comparte este curso',
    });
  }

  shareCourseDesktop() {
    const url = 'https://louderband.com/courses/' + this.course.id + '-' + this.course.slug;
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(async () => {
        const toast = await this.toastCtrl.create({
          message: 'La URL se ha copiado al portapapeles.',
          duration: 2000,
          position: 'top'
        });
        await toast.present();
      }).catch((async () => {
        const toast = await this.toastCtrl.create({
          message: 'No se pudo copiar la URL al portapapeles.',
          duration: 2000,
          position: 'top'
        });
        await toast.present();
      }));
    }
  }

  showModalSuscription() {
    this.modalSuscription = !this.modalSuscription;
  }

  shareDevice(index: number) {
    const element = document.querySelector('share-menu') as ShareMenu;
    element.targets[index].share(element);
  }

  presentPopoverShare(e: Event) {
    this.popoverShare.event = e;
    this.isOpenPopover = true;
  }

  closeModalLogin() {
    this.showModalLogin = false;
  }

  handlePromotionRequest() {
    setTimeout(async () => {
      if (this.promotion && this.promotion_course) {
        try {
          const promotionResponse = await this.rest._post('courses/promotion', { course: this.promotion_course, promotion: this.promotion }).toPromise();

          let toast = await this.toastCtrl.create({
            message: 'Ya puedes disfrutar de tu nuevo curso!',
            duration: 3000,
            position: 'middle'
          });
          await toast.present();

        } catch (promotionError) {
          let toast = await this.toastCtrl.create({
            message: promotionError.error.mensaje,
            duration: 3000,
            position: 'middle'
          });
          await toast.present();

          window.localStorage.removeItem('promotion');
          window.localStorage.removeItem('promotion_course');
          this.promotion = null;
          this.promotion_course = null;
        } finally {
          this.navCtrl.navigateRoot('cursos/' + this.course.id);
        }
      }


    }, 300);
  }

  async loginGoogle() {
    this.showModalLogin = false;
    const result = await GoogleAuth.signIn();
    console.log(result);

    const loading = await this.loadingCtrl.create({
      message: ''
    });
    loading.present();

    this.rest._post('google/login', result).subscribe(async (response) => {
      const user: any = response.body;
      this.rest.storageSet('user', user);
      this.util.setUser(user);
      this.util.setToken(user.token);

      window.localStorage.setItem('louderbandToken', user.token);

      loading.dismiss();

      this.handlePromotionRequest();

    }, (error) => {
      console.error('error: ', error);
      loading.dismiss();
    });

  }

  gotoLogin() {
    this.showModalLogin = false;
    const currentRoute = this.saveRouter.url;
    localStorage.setItem('currentRoute', currentRoute);
    this.navCtrl.navigateForward('/login');
  }

  gotoRegister() {
    this.showModalLogin = false;
    const currentRoute = this.saveRouter.url;
    localStorage.setItem('currentRoute', currentRoute);
    this.navCtrl.navigateForward('/registro');
  }

  loginApple() {
    this.appleWeb();
  }

  async appleWeb() {

    const provider = new OAuthProvider('apple.com');

    signInWithPopup(this.auth, provider).then((result: UserCredential) => {
      console.log(result);
      if (result) {
        this.helpApple(result.user);
      }
    });
  }

  async helpApple(response) {

    let params = {
      username: response.email,
      name: response.displayName,
      red_social: 'APPLE',
      id_usuario_red_social: response.uid,
      tokenApple: response.accessToken,
      email: response.email,
      respuesta: JSON.stringify(response),
      notification_id: '' //this.oneSignal.getPlayerId()
    };
    // alert(JSON.stringify(params));
    const loading = await this.loadingCtrl.create({
      message: ''
    });
    loading.present();
    this.rest._post('apple/login', params).subscribe(async (responseApple) => {
      const user: any = responseApple.body;
      this.util.setToken(user.token);
      this.rest.storageSet('user', user);
      loading.dismiss();
      let picture = null;

      window.localStorage.setItem('louderbandToken', user.token);
      this.handlePromotionRequest();

    }, (error) => {
      console.error('error: ', error);
      loading.dismiss();
    });
  }
}
